module.exports = __webpack_public_path__ + "img/cards-2.df9a8c69.jpg";